define('module/GdprReportModule',['require','marionette','model/GdprReportModuleModel','view/module/GdprReportView','lib/plugin/PluginBroker','lib/WindowMessageListener'],function (require) {

    var Marionette = require('marionette');
    var GdprReportModuleModel = require('model/GdprReportModuleModel');
    var GdprReportView = require('view/module/GdprReportView');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var WindowMessageListener = require('lib/WindowMessageListener');

    /**
     * Controller for reviews module
     *
     * @class ReviewModule
     */
    return Marionette.Object.extend({

        _regions: {
            gdpr: '#sb_gdpr_report_module_container'
        },
        _model: null,
        _layout: null,
        _view: null,
        _clientModel: null,

        /**
         * Inits instance
         */
        initialize: function () {
            this._layout = this.getOption('layout');

            this.initOpenIdAuth();

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._initView, this)
            );

            if (!this._clientModel) {
                if (Config.getInstance().getPluginStatus('client_login')) {
                    var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                    this._clientModel = clientPlugin.getClientModel();
                }
            }

            this._model = GdprReportModuleModel.getInstance();
            this.listenTo(this._clientModel, 'change', this.clientModelChanged);
            this.listenTo(this._model, 'change:result', this.reportModuleModelChanged);
        },

        clientModelChanged : function () {
            this._model.set('is_client_logged', this._clientModel.get('is_logged_in'));
        },

        reportModuleModelChanged : function(){
            var status = this._model.get('result');
            if(status){
                Backbone.Wreqr.radio.vent.trigger('gdpr', 'clientLogged');
            }
        },

        /**
         * Initializes regions and views
         *
         * @private
         */
        _initView: function () {
            _.each(this._regions, function (selector, region) {
                this._layout.addRegion(region, selector);
            }, this);

            //display gdpr module only if client login is disabled
            //if (!Config.getInstance().getPluginStatus('client_login')) {
                if (this._layout.gdpr && this._layout.gdpr.$el.length) {
                    if (!this._view || this._view.isDestroyed) {
                        this._view = this._getGDPRView();
                        this._layout.gdpr.show(this._view);
                    }
                }
            //}
        },

        _getGDPRView: function () {

            return new GdprReportView({
                model: this._model
            });
        },

        /**
         * Subscribe to message window event
         */
        initOpenIdAuth: function () {
            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            if (data.gdpr_open_id_message) {
                if(this._view){
                    this._view.triggerMethod('close:form');
                    Backbone.history.navigate('gdpr-report', {
                        trigger: true
                    });
                    jQuery(window).scrollTop(0);
                }
            }
        },


    });

});
